import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID, makeStateKey, TransferState } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BlogModel } from '../model/blog.model';

import { tap, catchError } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class BlogService {
  private readonly url = "https://api.1artifactware.com/articles"
  private readonly trackUrl = "https://api.1artifactware.com/marketing/resource"
  private readonly articleUrl =  `${this.url}/type/blog/slug`;

  constructor(
    private httpClient: HttpClient,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  slug(slug: string): Observable<BlogModel> {
    const key = makeStateKey<BlogModel>(`article-${slug}`);
    
    // Check if data exists in transfer state (from SSR)
    const cachedData = this.transferState.get(key, null);
    if (cachedData) {
      // Remove from transfer state to prevent memory leaks
      this.transferState.remove(key);
      return of(cachedData);
    }

    // Make HTTP request and cache the result
    return this.makeHttpRequest(slug, key);
  }

  private makeHttpRequest(slug: string, key: any): Observable<BlogModel> {
    return this
      .httpClient
      .get<BlogModel>(`${this.articleUrl}/${slug}`)
      .pipe(
        tap(data => {
          // Store in transfer state for SSR/prerendering
          this.transferState.set(key, data);
        }),
        catchError(error => {
          console.error(`API call failed for slug: ${slug}`, error);
          throw error;
        })
      );
  }

  track(resource: string): Observable<{  }> {
    return this
      .httpClient
      .get<{}>(`${this.trackUrl}/${resource}/read`);
  }
}
